<section class="bio-page">
  <div class="bio-hero">
    <div class="portrait-card">
      <p class="eyebrow">{{ language.isEnglish ? 'Biography' : 'Biographie' }}</p>
      <h1 class="artist-title">
        <span class="artist-name">C&eacute;cile</span>
        <span class="artist-name artist-surname">Binsztock</span>
        <span class="artist-role"><span aria-hidden="true"></span>{{ language.isEnglish ? 'Painter' : 'Peintre' }}</span>
      </h1>
      <img src="./assets/cecile_portrait.PNG" [alt]="language.isEnglish ? 'Portrait of Cécile Binsztock' : 'Portrait de Cécile Binsztock'" />
      <p class="portrait-note">{{ language.isEnglish ? 'Visual artist based in the Val d’Oise, France.' : 'Artiste peintre installée dans le Val d’Oise.' }}</p>
    </div>

    <article class="poem-card">
      <h2>{{ language.isEnglish ? 'CÉCILE B., PAINTER' : 'CÉCILE B., PEINTRE' }}</h2>
      @if (language.isEnglish) {
      <p class="poem-sub">[And a cry beneath the sun in a garden]</p>
      <p>
        Cécile B. holds back. Reserve, modesty. What can be painted that has not already been painted?
        What can be done that has not already been done and redone? Cécile B. is black. Cécile B. is white.
        Cécile B. is a woman of colours. Cécile B. is a colourist.
      </p>
      <p>
        She knows how colours blend, how they meet, overlap and contrast. She knows the line, the mark,
        the motif, the weave, opacity and transparency. She knows scratches, scrapings, grooves and textures
        in all their forms.
      </p>
      <p>
        She knows, yet she holds back. The vanity of demonstration, of display. Then suddenly, she lets go.
        A profusion of colours and forms. A generosity of materials.
      </p>
      <p>
        The outpouring of a sensitivity held in check, yet close to the surface—at the surface of skin,
        at the surface of paper. Like a refreshing summer rain.
      </p>
      <p>
        Cécile B. is natural. She is neither sophisticated nor contrived. It is no surprise that her works
        are visited by swarms of bees, flights of birds and schools of fish. No surprise that they are
        scattered with beds of flowers.
      </p>
      <p>
        The sea salts and nourishes her works, rivers irrigate them, the wind pollinates them,
        rain covers them with stars and the sun cracks their surface.
      </p>
      <p>
        Cécile B. holds back. But when she lets go, what a prodigious flowering, what natural jubilation,
        what a jubilant nature.
      </p>
      <p class="signature">Hamid Tibouchi</p>
      <p class="poem-sub">[Written in a garden, 2 April 2011]</p>
      } @else {
      <p class="poem-sub">[Et cri sous le soleil dans un jardin]</p>
      <p>
        C&eacute;cile B. se retient. R&eacute;serve, pudeur. Que peindre qui n&apos;ait d&eacute;j&agrave; &eacute;t&eacute; peint ?
        Que faire qui n&apos;ait d&eacute;j&agrave; &eacute;t&eacute; fait et refait ? C&eacute;cile B. est noire. C&eacute;cile B. est blanche.
        C&eacute;cile B. est femme de couleurs. C&eacute;cile B. est coloriste.
      </p>
      <p>
        Elle sait le m&eacute;lange des couleurs, leurs juxtapositions, leurs recouvrements, leurs contrastes.
        Elle sait le trait, la tache, le motif, la trame, l&apos;opacit&eacute;, la transparence. Elle sait les griffures,
        les raclures, les rainures, les textures, sous toutes les coutures.
      </p>
      <p>
        Elle sait, mais elle se retient. Vanit&eacute; de la d&eacute;monstration, de la monstration. Et tout &agrave; coup,
        elle se l&acirc;che. D&eacute;bauche de couleurs, de formes. G&eacute;n&eacute;rosit&eacute; des mati&egrave;res.
      </p>
      <p>
        Ruissellement d&apos;une sensibilit&eacute; contenue, mais &agrave; fleur de peau, &agrave; fleur de papier.
        Comme une pluie d&apos;&eacute;t&eacute; rafra&icirc;chissante.
      </p>
      <p>
        C&eacute;cile B. est naturelle. Elle n&apos;est pas sophistiqu&eacute;e, pas feinte non plus. Pas &eacute;tonnant que ses travaux
        soient visit&eacute;s par des essaims d&apos;abeilles, des vols d&apos;oiseaux, des bancs de poissons. Pas &eacute;tonnant
        qu&apos;ils soient parsem&eacute;s de massifs de fleurs.
      </p>
      <p>
        Ses travaux, la mer les sale et les f&eacute;conde, les rivi&egrave;res les irriguent, le vent les pollinise,
        la pluie les &eacute;toile, le soleil les craquelle.
      </p>
      <p>
        C&eacute;cile B. se retient. Mais quand elle se l&acirc;che, quelle floraison prodigieuse,
        quelle jubilation naturelle, quelle nature jubilatoire.
      </p>
      <p class="signature">Hamid Tibouchi</p>
      <p class="poem-sub">[&Eacute;crit dans un jardin, le 2 avril 2011]</p>
      }
    </article>
  </div>

  <section class="summary-card">
    <h3>{{ language.isEnglish ? 'Exhibitions and career' : 'Expositions et parcours' }}</h3>
    @if (language.isEnglish) {
    <ul>
      <li>Lives and works in the Val d’Oise, France, where she has been based for 40 years.</li>
      <li>Solo and group exhibitions since 1985.</li>
      <li>Haute-Maurienne Astronomy Festival and Maison de l’Astronomie, Paris.</li>
      <li>Jean-Jacques Rousseau Museum, Montmorency.</li>
      <li>Archaeology Museum, Guiry-en-Vexin.</li>
      <li>Exhibitions with Art Chauve and Art Rencontre Val d’Oise.</li>
      <li>Other group exhibitions in Cergy, Bouffémont, Taverny, L’Isle-Adam, Bessancourt, Eaubonne, Fleurance, Audierne, Saint-Brieuc and Marmande.</li>
    </ul>
    } @else {
    <ul>
      <li>Vit et travaille dans le Val d&apos;Oise depuis 40 ans.</li>
      <li>Expositions personnelles et collectives depuis 1985.</li>
      <li>Festival d&apos;astronomie de Haute-Maurienne, Maison de l&apos;Astronomie &agrave; Paris.</li>
      <li>Mus&eacute;e J.-J. Rousseau &agrave; Montmorency.</li>
      <li>Mus&eacute;e d&apos;Arch&eacute;ologie de Guiry-en-Vexin.</li>
      <li>Expositions dans le cadre de l&apos;Art Chauve et Art Rencontre Val d&apos;Oise.</li>
      <li>Autres expositions collectives &agrave; Cergy, Bouff&eacute;mont, Taverny, L&apos;Isle-Adam, Bessancourt, Eaubonne, Fleurance, Audierne, Saint-Brieuc, Marmande.</li>
    </ul>
    }
  </section>
</section>
